<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/B1l0Xw/tc-custom/FC-9789948366577.jpg?1684514747622?1705540687185" alt="This image is the cover for the book The Royal Falconer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Royal Falconer
      </h1>
      <p class="bookDescription body article font2">
        <p>Following the death of her husband, a Saxon Earl more than twice her age, a young Norman lady of noble birth is allowed to return to her home in France. But that journey is fraught with danger. Conspiracy, family secrets, stolen jewellery and a raid by Welsh brigands from across the border all conspire against her. Arrested and thrown into dungeon and then threatened with torture, she is made to stand trial for theft and murder. This is a medieval mystery of epic proportions, full of twists and turns, and culminating in the trial of Lady Adela Fitzgerald. But can the arrival of the king's royal falconer unravel the mysteries and prove the innocence of the Norman lady before it is too late? Can he save her from the gallows?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Norbert Van De Hemn
      </h2>
      
      <p class="authorDescription body article">The author was born in 1945 and educated in Stourbridge, West Midlands. He married in 1968 and moved to Shropshire in 1971. He had four children, twelve grandchildren and one great-grandchild. He passed away before the publication of this book at the age of 74 on 24 June 2019.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6adee18e